import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { homeLogoPath } from '../../utils/hubNavigation';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';

const DynamicFFLogoRoute = ({ children }) => {
	const { authenticated, loading, fitnessHubsOnly } = useAuth();

	if (loading) {
		return (
			<div>
				<LoadingSpinner />
			</div>
		);
	}

	if (authenticated) {
		return (
			<Navigate to={homeLogoPath({ authenticated, fitnessHubsOnly })} />
		);
	}

	if (!authenticated) {
		return children;
	}
};

export default DynamicFFLogoRoute;
